import { render, staticRenderFns } from "./ProductCustomisationModal.vue?vue&type=template&id=a1fc2b86&scoped=true&"
import script from "./ProductCustomisationModal.vue?vue&type=script&lang=js&"
export * from "./ProductCustomisationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fc2b86",
  null
  
)

export default component.exports